// import { useState, useEffect } from "react";
// import { loadCountryList } from "../../services/locationService";
// import { loadWarehouseBinTypeList, loadWarehouseBintypeListByStatus, loadWarehouseEnvironmentList, loadWarehouseTypeList } from "../../services/warehouseService";

// const useWarehouseBinTypeList = (status,editID) => {

//     const [warehouseBinTypes, setWarehouseBinTypes] = useState([]);
//     const [selectedWarehouseBinType, setSelectedWarehouseBinType] = useState(null);
//     const [selectedWarehouseBinTypeID, setSelectedWarehouseBinTypeID] = useState(null);
//     const [isWarehouseBinTypeDataLoaded, setIsWarehouseBinTypeDataLoaded] = useState(false);

//     // Fetch department data
//     const fetchWarehouseBinTypeList = async (selectedID = null) => {


//         try {

//             let data;
//             if (status !== null) {
//                 const para = {
//                     p_company_id: localStorage.getItem("companyid"),
//                     p_plant_id: 1,
//                     p_status: status
//                 };

//                 data = await loadWarehouseBintypeListByStatus(para);
//             } else {
//                 data = await loadWarehouseBinTypeList({
//                     p_companyid: localStorage.getItem("companyid")
//                 });
//             }



//             if (data && data.length > 0) {
//                 setWarehouseBinTypes(data);
//                 const initialWarehouseBinType = data.find((dept) => dept.bin_type_id === selectedID);

//                 if (initialWarehouseBinType) { // ✅ Corrected check
//                     setSelectedWarehouseBinType(initialWarehouseBinType);
//                     setSelectedWarehouseBinTypeID(initialWarehouseBinType.bin_type_id);
//                     setIsWarehouseBinTypeDataLoaded(true);
//                 }

//             }
//         } catch (error) {
//             // CallMessage("error", error.message, "Error");
//         }
//     };

//     // Load warehouse bin types when the component mounts
//     useEffect(() => {
//         if (!isWarehouseBinTypeDataLoaded) {
//             const loadWarehouseBinTypes = async () => {
//                 await fetchWarehouseBinTypeList();
//             };
//             loadWarehouseBinTypes();
//         }
//     }, [isWarehouseBinTypeDataLoaded, editID]);

//     // Function to load warehouse bin type based on selected ID
//     const loadWarehouseBinTypeByID = async (selectedID) => {
//         await fetchWarehouseBinTypeList(selectedID);
//     };

//     return {
//         warehouseBinTypes,
//         selectedWarehouseBinType,
//         selectedWarehouseBinTypeID,
//         setSelectedWarehouseBinType,
//         setSelectedWarehouseBinTypeID,
//         loadWarehouseBinTypeByID,
//     };
// };

// export default useWarehouseBinTypeList;


import { useState, useEffect } from "react";
import {
  loadWarehouseBinTypeList,
  loadWarehouseBintypeListByStatus,
} from "../../services/warehouseService";

const useWarehouseBinTypeList = (status, editID) => {
  const [warehouseBinTypes, setWarehouseBinTypes] = useState([]);
  const [selectedWarehouseBinType, setSelectedWarehouseBinType] = useState(null);
  const [selectedWarehouseBinTypeID, setSelectedWarehouseBinTypeID] = useState(null);
  const [isWarehouseBinTypeDataLoaded, setIsWarehouseBinTypeDataLoaded] = useState(false);

  const fetchWarehouseBinTypeList = async (selectedID = null) => {
    try {
      let data = [];

      // 🔹 Step 1: Try to load by status (active/inactive)
      if (status !== null) {
        const para = {
          p_company_id: localStorage.getItem("companyid"),
          p_plant_id: 1,
          p_status: status,
        };
        data = await loadWarehouseBintypeListByStatus(para);
      } else {
        data = await loadWarehouseBinTypeList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 2: Fallback — if no active found, load all
      if ((!data || data.length === 0) && status === true && selectedID) {
        data = await loadWarehouseBinTypeList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 3: Continue like before
      if (data && data.length > 0) {
        let updatedList = [...data];
        let initialType = data.find((t) => t.bin_type_id === selectedID);

        if (!initialType && selectedID) {
          const allData = await loadWarehouseBinTypeList({
            p_companyid: localStorage.getItem("companyid"),
          });
          const inactiveType = allData.find((t) => t.bin_type_id === selectedID);
          if (inactiveType) {
            updatedList.push(inactiveType);
            initialType = inactiveType;
          }
        }

        setWarehouseBinTypes(updatedList);
        if (initialType) {
          setSelectedWarehouseBinType(initialType);
          setSelectedWarehouseBinTypeID(initialType.bin_type_id);
        }

        setIsWarehouseBinTypeDataLoaded(true);
      } else {
        // 🔹 Step 4: Handle case where no bin types exist
        setSelectedWarehouseBinType(null);
        setSelectedWarehouseBinTypeID(null);
        setWarehouseBinTypes([]);
        setIsWarehouseBinTypeDataLoaded(true);
      }
    } catch (error) {
      console.error("Error fetching warehouse bin types:", error);
    }
  };

  useEffect(() => {
    if (!isWarehouseBinTypeDataLoaded && editID === 0) {
      fetchWarehouseBinTypeList();
    }
  }, [isWarehouseBinTypeDataLoaded, editID]);

  const loadWarehouseBinTypeByID = async (selectedID) => {
    await fetchWarehouseBinTypeList(selectedID);
  };

  return {
    warehouseBinTypes,
    selectedWarehouseBinType,
    selectedWarehouseBinTypeID,
    setSelectedWarehouseBinType,
    setSelectedWarehouseBinTypeID,
    setIsWarehouseBinTypeDataLoaded,
    loadWarehouseBinTypeByID,
  };
};

export default useWarehouseBinTypeList;
